import { lazyComponent } from '@/utils/lazyComponent'

// ui-groups(컨덕터 그룹 사본)를 처음 쓰는 화면이라 청크를 나눈다 — GL18 을 열지 않는 사용자는 받지 않는다(입고작업 2.0 GL17 과 같다).
export default lazyComponent(() => import('./index'))
